const COFFEE_COMMUNITIES_CONSTANTS = {
  PAGE_SIZE: 20,
  MAX_FILE_SIZE: 200 * 1024 * 1024, // 200 MB
  MAX_FILES: 100,
  MAX_PREVIEW_CHARS: 240,
  RETRY_DELAY: 2000,
  MAX_RETRIES: 3,
  BUCKET_NAME: 'chat_media',
  TEXTAREA_MAX_HEIGHT: 200
}

export default COFFEE_COMMUNITIES_CONSTANTS
